import { State } from '../reducers/types'

export const getAuthToken = (state: State): string | null => state.auth.authToken

export const getIsTokenSignIn = (state: State): boolean | null => state.auth.isTokenSignIn

export const getContractorPortalAuthToken = (state: State): string | null =>
  state.contractorPortalAuth.contractorPortalAuthToken

export const getResendAvailableAt = (state: State): string | null => state.auth.resendAvailableAt

export const getResendRemainingCount = (state: State): number | null =>
  state.auth.resendRemainingCount

export const getValidateLockedUntil = (state: State): string | null =>
  state.auth.validateLockedUntil

export const getAttemptsRemaining = (state: State): number | null => state.auth.attemptsRemaining

export const getContractorPortalResendAvailableAt = (state: State): string | null =>
  state.contractorPortalAuth.resendAvailableAt

export const getContractorPortalResendRemainingCount = (state: State): number | null =>
  state.contractorPortalAuth.resendRemainingCount

export const getContractorPortalValidateLockedUntil = (state: State): string | null =>
  state.contractorPortalAuth.validateLockedUntil

export const getContractorPortalAttemptsRemaining = (state: State): number | null =>
  state.contractorPortalAuth.attemptsRemaining
